'use client';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { primary, textColor } from '@style/variables';
import HelpIcon from '@repo/ui/src/components/Icons/HelpIcon';

const IndividualInstruction = ({ image, title, descirption }) => {
  const imgUrl = image ? buildImageSrc(image, 110, 11, 2) : null;

  return (
    <div className="text-left mt-4">
      <div className="col px-0">
        {imgUrl ? <img className="text-left mb-3" src={imgUrl} alt={title} /> : null}
        {title ? <h4 className="text-left mb-3">{title}</h4> : null}
        {descirption ? <p className="text-left mb-3">{descirption}</p> : null}
      </div>
    </div>
  );
};

const SideModalInstructions = ({ body, title, description }) => {
  const [show, setShow] = useState(false);
  const [iconHovered, setIconHovered] = useState(false);

  return (
    <>
      <button
        className="tw-cursor-pointer ml-sm-2 d-flex align-items-center"
        onClick={() => setShow(true)}
        onMouseOver={() => setIconHovered(true)}
        onMouseLeave={() => setIconHovered(false)}
      >
        <HelpIcon color={iconHovered ? primary : textColor} />
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-one-third-left"
        aria-labelledby="modal-styling-title"
        className="left-modal-fade tw-z-[2000]"
      >
        <div className="mt-2 mx-5">
          <Modal.Header closeButton />
          {title ? (
            <Modal.Title className="text-left pl-3" id="modal-styling-title">
              <h2>{title}</h2>
            </Modal.Title>
          ) : null}
          <Modal.Body>
            {description ? <p className="text-left">{description}</p> : null}
            {body ? body.map((item, i) => <IndividualInstruction key={i} {...item} />) : null}
            <p className="text-left" />
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default SideModalInstructions;
